module.exports = __webpack_public_path__ + "img/Image 5.7a9fd00f.png";